import * as types from './checkList.types';
import * as constants from './checkList.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeCheckList = generateStoreResourceAction<types.ICheckList>(constants.STORE_CHECKLIST);
export const clearCheckList = generateClearResourceAction(constants.CLEAR_CHECKLIST);
